import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import HomeHeader from './components/HomeHeader';
import Home from './pages/home/Home';
import "./main.scss"

const root = ReactDOM.createRoot(document.querySelector("#reactroot"))

root.render(
  <Router>
    <HomeHeader />
    <main id='main'>
      <Home />
    </main>
  </Router>
);
